<template>
  <v-container fluid class="mt-7 pa-0">
    <v-data-table
      v-model="selected_urls_of_product"
      :headers="headers"
      :items="product_urls"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :single-select="singleSelect"
      item-key="url_id"
      :search="selectFor"
      show-select
      show-expand
      class="elevation-1"
      :loading="!product_urls.length && loading"
      :items-per-page="!!size_of_table ? size_of_table :product_urls.length"
    >
      <!-- :loading="$store.state.competitorsModule.loading && product_urls.length < 1"
      loading-text="Loading... Please wait" -->

      <template v-slot:top>
        <v-toolbar extended>
          <v-toolbar-title class="ms-4">{{ selected_product.product_id }}</v-toolbar-title>
          <v-divider vertical class="mx-4" />
          <v-toolbar-title class="ms-4 warning--text">{{ product_type }}</v-toolbar-title>
          <v-divider vertical class="mx-4" />
          <v-toolbar-title>{{ selected_product.product_brand.name }}</v-toolbar-title>
          <v-divider vertical class="mx-4" />
          <v-toolbar-title>{{ selected_product.product_name }}</v-toolbar-title>
          <v-icon
            class="mx-1"
            color="primary darken-2"
            @click="prepareEditProduct"
          >
            edit
          </v-icon>
          <v-spacer></v-spacer>
          <v-btn class="me-3" color="secondary" @click="linkDialog = true">
            LINK
          </v-btn>
          <v-toolbar-title>Clients: {{ (clients.length === 0) ? "No Clients" : clients.join(" , ") }}</v-toolbar-title>
              <!-- <v-spacer></v-spacer> -->
          <template v-slot:extension>
              <v-btn color="red darken-4" @click="add_url_dialog = true">
                <v-icon>add</v-icon>ADD URL
              </v-btn>
              <v-spacer></v-spacer>
              <v-text-field
                label="Search"
                v-model="selectFor"
                class="pa-3"
                append-icon="mdi-magnify"
                single-line
                style="width: 40px"
                hide-details
              />
              <v-spacer></v-spacer>
              <v-select
                v-if="isFromSyncList"
                v-model="product_status"
                label="Status"
                :items="sync_status"
                class="status-select me-5"
                solo
                outlined
                dense
                hide-details
                :color="statusColor"
                @change="change_product_status"
                :loading="loading"
                :disabled="loading"
                item-text="title"
                item-value="status_id"
              />
              <!-- <v-spacer></v-spacer> -->
              <v-menu
                v-if="isFromSyncList"
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="product_requested_at"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="product_requested_at"
                    label="Requested at"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="me-5"
                    style="width: 30px"
                    hide-details
                    :loading="date_loader"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="product_requested_at"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(product_requested_at); updateCreated_at(product_requested_at)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
              <v-tooltip bottom v-if="isFromSyncList && !!selectedProductSpecs.product_info.completed_from">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      info
                    </v-icon>
                  </span>
                </template>
                <div class="d-flex flex-column">
                  <span>
                    Completed From: {{ selectedProductSpecs.product_info.completed_from }}
                  </span>
                  <span>
                    Completed At: {{ selectedProductSpecs.product_info.completed_at.date }}
                  </span>
                </div>
              </v-tooltip>
          <!-- <v-switch
            v-model="singleSelect"
            label="Single select"
            class="pa-3"
          ></v-switch>
          <v-switch
            v-model="singleExpand"
            label="Single expand"
            class="mt-2"
          ></v-switch> -->
          </template>
        </v-toolbar>
      </template>
      <template v-slot:item.ean="{ item }">
        <span :class="{'red--text': item.ean == 'Not found'}">{{ item.ean }}</span>
      </template>
      <template v-slot:item.sku="{ item }">
        <span :class="{'red--text': item.sku == 'Not found'}">{{ item.sku }}</span>
      </template>
      <template v-slot:item.mpn="{ item }">
        <span :class="{'red--text': item.mpn == 'Not found'}">{{ item.mpn }}</span>
      </template>
      <template v-slot:item.url="{ item }">
        <div class="domain_row_header_url d-flex flex-row mt-1">
          <v-btn
            @click.native.stop="copyLink"
            fab
            dark
            x-small
            title="Copy the link"
            class="mr-2"
            color="secondary"
          >
            <v-icon>content_copy</v-icon>
          </v-btn>
          <!-- <span class="d-inline-block text-truncate" style="max-width: 1000px;"> -->
              <!-- style="max-width: 700px" -->
              <!-- class="link_text d-inline-block text-truncate" -->
          <span
            class="link_text"
            @click="openUrl_dialog(item)"
          >
            {{ decode_url(item.url) }}
          </span>
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex flex-row">
          <v-icon
            class="mx-1"
            color="primary darken-2"
            @click="prepareEdit(item)"
          >
            edit
          </v-icon>
          <v-icon
            class="mx-1"
            color="red darken-2"
            @click="prepareDelete(item)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
      <template v-slot:item.title="{ item }">
        <a :href="item.url" target="_blank" rel="noopener noreferrer">{{
          item.title
        }}</a>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-container fluid>
            <SellerDetails
              :selected="[]"
              :sellers="item.sellers"
              :productUrlId="item.url_id"
            />
          </v-container>
        </td>
      </template>
    </v-data-table>
    <v-dialog max-width="1000" v-model="linkDialog">
      <Link
        :product_id="selected_product.product_id"
        :clients="clients"
        @exit_link="linkDialog = false"
        @success_linking="after_linking"
      />
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="800"
      v-model="edit_item_dialog.show"
    >
      <v-card>
        <v-toolbar>Edit {{ edit_item_dialog.item_after_edit.domain_name }}</v-toolbar>
        <v-card-text>
          <span>Old URL: {{ edit_item_dialog.item_before_edit.url }}</span>
          <v-text-field
            class="indigo--text mt-3"
            v-model="edit_item_dialog.item_after_edit.url"
            outlined
            clearable
          ></v-text-field>
          <span>Old SKU: {{ edit_item_dialog.item_before_edit.sku }}</span>
          <v-text-field
            label="SKU"
            class="indigo--text mt-3"
            v-model="edit_item_dialog.item_after_edit.sku"
            outlined
            clearable
          ></v-text-field>
          <span>Old EAN: {{ edit_item_dialog.item_before_edit.ean }}</span>
          <v-text-field
            label="EAN"
            class="indigo--text mt-3"
            v-model="edit_item_dialog.item_after_edit.ean"
            outlined
            clearable
          ></v-text-field>
          <span>Old MPN: {{ edit_item_dialog.item_before_edit.mpn }}</span>
          <v-text-field
            label="MPN"
            class="indigo--text mt-3"
            v-model="edit_item_dialog.item_after_edit.mpn"
            outlined
            clearable
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <!-- :disabled="is_same_url || !is_valid_url" -->
          <v-btn
            color="green darken-3"
            @click="editItem"
            :loading="loading"
            :disabled="same_item"
          >
            <v-icon>check</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="edit_item_dialog.show = false" color="red darken-4">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="800"
      v-model="edit_product_dialog.show"
    >
      <v-card>
        <v-toolbar>Edit Product</v-toolbar>
        <v-card-text>
          <v-container class="my-2">
            <span class="mb-1" >Old URL: {{ edit_product_dialog.product_before_edit.name }}</span>
            <v-text-field
              v-model="edit_product_dialog.product_after_edit.name"
              outlined
              clearable
              hide-details
            ></v-text-field>
          </v-container>
          <v-container class="my-2">
            <span class="mb-1" v-if="edit_product_dialog.product_before_edit.brand.id"
            >Old Brand id: {{ edit_product_dialog.product_before_edit.brand.id }}, name : {{ edit_product_dialog.product_before_edit.brand.name }}</span>
            <v-autocomplete
              :items="manufacturers"
              v-model="edit_product_dialog.product_after_edit.brand"
              :search-input.sync="sync_manufacturer"
              noFilter
              :ripple="false"
              clearable
              outlined
              hide-details
              clear-icon
              append-icon="expand_more"
              item-text="name"
              return-object
              label="Manufacturer"
              text
            />
          </v-container>
          <v-container class="my-2">
            <span class="mb-1" >Old Brand: {{ edit_product_dialog.product_before_edit.type }}</span>
            <v-select
              v-model="edit_product_dialog.product_after_edit.type"
              mandatory
              outlined
              hide-details
              :items="[{text: 'Exact',value: 'exact'}, {text: 'Similar',value: 'similar'}]"
              append-icon="expand_more"
              label="Type"
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-3"
            @click="editProduct"
            :loading="product_loading"
            :disabled="same_product"
          >
            <v-icon>check</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="edit_product_dialog.show = false" color="red darken-4">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="700"
      v-model="delete_dialog.show"
    >
      <v-card>
        <!-- <v-toolbar>{{ delete_dialog.item.domain_name }}</v-toolbar> -->
        <v-card-title>{{ delete_dialog.item.domain_name }}</v-card-title>
        <v-card-subtitle class="my-3">{{ delete_dialog.item.url }}</v-card-subtitle>
        <v-card-text> Are you sure you want to delete it? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-3" @click="deleteItem" :loading="loading">
            <v-icon>check</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="delete_dialog.show = false" color="red">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="80%" v-model="add_url_dialog">
      <AddUrl @close_validation="add_url_dialog = false" />
    </v-dialog>
    <v-dialog v-model="url_dialog.show">
      <v-card>
        <v-card-title>{{ url_dialog.item.domain_name }}</v-card-title>
        <v-card-text>{{ decodeURI(url_dialog.item.url) }}</v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog max-width="80%" v-model="massive_delete_dialog">
      <v-card>
        <v-card-title>Delete these urls?</v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="item in selected_urls_of_product" :key="item.url_id">{{ decodeURI(item.url) }}</v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="d-flex flex-row justify-space-around">
          <v-btn @click="massive_delete_dialog = false">NO</v-btn>
          <v-btn :loading="massive_delete_loader" @click="massiveDeleteUrls">YES</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */
import AddUrl from "@/components/production/N_Add_Url.vue";
import { exractProductDomains, myCapitallize } from "@/helpers/functions.js";
import SellerDetails from "@/components/production/N_SellerDetails.vue";
import Link from "@/components/production/N_Link.vue";
import { productionBus } from "@/helpers/buses";

export default {
  name: "N_ProductDetailsTable_2",
  components: {
    AddUrl,
    SellerDetails,
    Link,
  },
  props: {
    size_of_table: {
      type: Number || Boolean,
      default: 0,
      required: false,
    },
  },
  data: () => ({
    // product_requested_at: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    delete_dialog: {
      show: false,
      item: {},
    },
    edit_item_dialog: {
      show: false,
      item_after_edit: {},
      item_before_edit: {},
    },
    edit_product_dialog: {
      show: false,
      product_after_edit: {brand: {}},
      product_before_edit: {brand: {}},
    },
    sync_manufacturer: '',
    manufacturers: [],
    product_loading: false,
    url_dialog: {
      show: false,
      item: {},
    },
    linkDialog: false,
    linkSwitch: false,
    linkClients: [], // link v-model
    // selected_urls_of_product: [],
    add_url_dialog: false,
    expanded: [],
    singleExpand: false,
    singleSelect: false,
    selectFor: "",
    // selected: [],
    headers: [
      {
        text: "Domain",
        align: "start",
        value: "domain_name",
      },
      { text: "EAN", value: "ean" },
      { text: "SKU", value: "sku" },
      { text: "MPN", value: "mpn" },
      { text: "MIN", value: "min_price" },
      { text: "MAX", value: "max_price" },
      // { text: "Variation", value: "variation_text" },
      { text: "Url", value: "url" },
      { text: "Actions", value: "actions", sortable: false },
      // { text: 'Price', value: 'price' },
    ],
    massive_delete_dialog: false,
    massive_delete_loader: false,
    date_loader: false,
  }),
  computed: {
    same_item() {
      return JSON.stringify(this.edit_item_dialog.item_before_edit) === JSON.stringify(this.edit_item_dialog.item_after_edit)
    },
    same_product() {
      return JSON.stringify(this.edit_product_dialog.product_before_edit) === JSON.stringify(this.edit_product_dialog.product_after_edit)
    },
    selectedProductSpecs() {
      return this.$store.state.productionModule.selected_product.specs;
    },
    product_type () {
      // return this.selectedProductSpecs.product_info.product_type.toUpperCase();
      return ( !!this.selectedProductSpecs.product_info )
              ? this.selectedProductSpecs.product_info.product_type.toUpperCase()
              : 'UNDEFINED';
    },
    clients() {
      return this.$store.getters["productionModule/selected_product_clients_names"];
    },
    clients_ids() {
      return this.$store.getters["productionModule/selected_product_clients_ids"];
    },
    selected_product() {
      return this.$store.state.productionModule.loaded_products.find(
        (x) =>
          x.product_id ===
          this.$store.state.productionModule.selected_product.id
      );
    },
    selected_urls_of_product: {
      get() {
        return this.$store.state.productionModule.selected_urls_of_product;
      },
      set(value) {
        const data = {
          key: "selected_urls_of_product",
          value: value,
        };
        this.$store.commit("productionModule/SET_PRODUCTION_STATE", data);
      },
    },
    product_urls() {
      return this.exractProductDomains(
        this.$store.state.productionModule.selected_product.specs.product_domains
      );
    },
    availiable_clients_for_select() {
      return [];
    },
    // loading () {
    //   return this.$store.state.productionModule.loading;
    // },
    loading: {
      get() {
        return this.$store.state.productionModule.loading;
      },
      set(value) {
        this.$store.commit("productionModule/SET_PRODUCTION_STATE", {value, key: 'loading'})
      }
    },
    product_status: {
      get() {
        return this.$store.state.productionModule.selected_product.status;
      },
      set(value) {
        this.$store.commit("productionModule/SET_SELECTED_PRODUCT_STATUS", value);
      }
    },
    isPending() {
      return this.$store.state.productionModule.product_filter.product_status === 'pending';
    },
    statusColor() {
      return 'red';
    },
    sync_status () {
      return this.$store.state.productionModule.sync_status;
    },
    isFromSyncList() {
      return ( this.selectedProductSpecs.product_info && this.selectedProductSpecs.product_info.list ) ? !!this.selectedProductSpecs.product_info.list : false
      // return sync_status.map(v => v.status_id).includes(product_status)
    },
    product_requested_at: {
      get() { return (this.selectedProductSpecs.product_info) ? this.selectedProductSpecs.product_info.requested_at.date : '1949-01-01' },
      set(value) { this.$store.commit("productionModule/SET_product_requested_at", value)}
    }
  },
  methods: {
    exractProductDomains,
    reset_linkClients() {},
    change_product_status() {
      this.loading = true;
      const prod_id = this.$store.state.productionModule.selected_product.id;
      const data = {
        task: "change_product_status",
        payload: {
          product_id: prod_id,
          status: this.product_status,
          }
      };
      this.$store.dispatch("productionModule/general_api", data)
      .then( res => {
        // this.
        console.log( 'find_product_status results', res.data );
        // this.product_status = res.data.payload.status;
        const obj = {id: prod_id, status: this.product_status};
        this.$store.commit("productionModule/UPDATE_LOADED_PRODUCTS_STATUS", obj);
      }).finally(() => { this.loading = false });
    },
    // get_product_status() {
    //   const data = {
    //     task: "find_product_status",
    //     payload: { product_id: this.$store.state.productionModule.selected_product.id }
    //   };
    //   this.$store.dispatch("productionModule/general_api", data)
    //   .then( res => {
    //     console.log( 'find_product_status results', res.data );
    //     this.product_status = res.data.product_status;
    //   })
    // },
    prepareEdit(item) {
      console.log("prepare for edit item", item);
      this.edit_item_dialog.item_before_edit = { ...item };
      this.edit_item_dialog.item_after_edit = { ...item };
      this.edit_item_dialog.show = true;
    },
    editItem() {
      this.loading = true;
      const edit_url_data = {
        task: "editUrl",
        payload: {
          product_id: this.edit_item_dialog.item_after_edit.product_id,
          domain_id: this.edit_item_dialog.item_after_edit.domain_id,
          url_id: this.edit_item_dialog.item_after_edit.url_id,
          old_item: this.edit_item_dialog.item_before_edit,
          new_item: this.edit_item_dialog.item_after_edit,
          // new_url: this.edit_item_dialog.item_after_edit.url,
          // sku: this.edit_item_dialog.item_after_edit.sku,
          // ean: this.edit_item_dialog.item_after_edit.ean,
          // mpn: this.edit_item_dialog.item_after_edit.mpn,
        },
      };
      this.$store
        .dispatch("productionModule/general_api", edit_url_data)
        .then((res) => {
          console.log("success edit url", res);
          this.$store.commit("productionModule/UPD_NEW_URL", this.edit_item_dialog.item_after_edit);
          this.edit_item_dialog.show = false;
        })
        .catch((err) => {
          console.log("error", err);
        }).finally(() => { this.loading = false; });
    },
    prepareEditProduct() {
      const product = {
        id: this.selected_product.product_id,
        name: this.selected_product.product_name,
        brand: this.selected_product.product_brand,
        type: this.product_type.toLowerCase(),
      }
      this.sync_manufacturer = this.selected_product.product_brand.name;
      console.log('edit product', product)
      this.edit_product_dialog.product_before_edit = { ...product };
      this.edit_product_dialog.product_after_edit = { ...product };
      this.edit_product_dialog.show = true;
    },
    editProduct() {
      console.log('edit Product')
      this.product_loading = true;
      // this.edit_product_dialog.product_after_edit.type = this.edit_product_dialog.product_after_edit.type.toLowerCase();
      const payload = {
        task: "editProductName",
        payload: this.edit_product_dialog.product_after_edit,
      };
      this.$store
        .dispatch("productionModule/general_api", payload)
        .then((res) => {
          const product_infos = res.data.product_infos;
          this.$store.commit("productionModule/UPDATE_SELECTED_PRODUCT", product_infos);
        })
        .catch((err) => {
          console.log("error", err);
        }).finally(() => {
          this.product_loading = false;
          this.edit_product_dialog.show = false;
          this.$emit("reload_product");
        });
    },
    prepareDelete(item) {
      console.log("preparation for delete item: ", item);
      this.delete_dialog.show = true;
      this.delete_dialog.item = item;
    },
    deleteItem() {
      this.loading = true;
      const payload = {
        // task: "deleteUrl",
        task: "deleteProductTracks",
        payload: {
          url_id: this.delete_dialog.item.url_id,
          product_id: this.delete_dialog.item.product_id,
          track_ids: this.delete_dialog.item.sellers.map((t) => t.track_id),
        },
      };
      console.log("check tracks for delete", payload);
      this.$store
        .dispatch("productionModule/general_api", payload)
        .then((res) => {
          console.log("success delete url", res);
          const deleted_item = {
            url_id: this.delete_dialog.item.url_id,
            domain_id: this.delete_dialog.item.domain_id,
          };
          this.delete_dialog.show = false;
          this.$store.commit("productionModule/DELETE_URLS", deleted_item);
        })
        .catch((err) => {
          console.log("error", err);
        }).finally(() => { this.loading = false; });
    },
    link_unlink_to_clients() {
      // keep in [] only the client ids (linkClients.value)
      // const clients_ids = this.linkClients.map(x => x.value);
      // const clients_ids = this.clients_list
      //                     .filter(x => this.linkClients.includes(x.value))
      //                     .map(x => x.value);
      console.log("selected array of clients ids", this.clients_ids);
      //create the payload for api
      const task = this.linkSwitch ? "linkToClients" : "unlinkFromClients";
      // const task = (linkSwitch) ? 'linkResolvedProduct' : 'unlinkResolvedProduct';
      const payload = {
        clients: this.clients_ids,
        product_ids: [
          this.merge_container.product_conflict.product_info.product_id,
        ],
      };
      console.log("send - ", { task, payload });
      this.$store
        .dispatch("productionModule/general_api", { task, payload })
        .then((res) => {
          this.notify("Link to client", "Client saved!");
          console.log("link-unlink results", res);
          if (this.linkSwitch) {
            this.clients.push(...this.linkClients.map((x) => x.text));
          } else {
            const linkedClients_texts = this.linkClients.map((x) => x.text);
            this.clients = this.clients.filter(
              (x) => !linkedClients_texts.includes(x)
            );
          }
          // if(linkSwitch){
          //   this.$store.commit("productModule/SET_LINKED_CLIENTS", )
          // } else {
          //   this.$store.commit("productModule/SET_LINKED_CLIENTS", )
          // }
        })
        .catch((err) => {
          this.notify("Error", "Client dont linked!");
        });

      // reset values
      this.linkDialog = false;
      this.linkClients = [];
    },
    copyLink({ target }) {
      const link = target
        .closest(".domain_row_header_url")
        .querySelector(".link_text").innerText;
      const tempElement = document.createElement("input");
      tempElement.value = link;
      document.getElementsByTagName("body")[0].append(tempElement);
      tempElement.select();
      document.execCommand("copy");
      tempElement.remove();
    },
    after_linking() {
      this.linkDialog = false;
      this.$emit("reload_product");
    },
    openUrl_dialog(item) {
      console.log('show item', item)
      this.url_dialog.item = item;
      this.url_dialog.show = true;
    },
    decode_url(url){
      try {
        const new_url = decodeURI(url);
        return new_url;
      } catch (error) {
        return url;
      }
    },
    massiveDeleteUrls () {
      this.massive_delete_loader = true;
      const task = 'deleteProductTracks';
      const payload = {
          product_id: this.selected_product.product_id,
          track_ids: this.selected_urls_of_product.flatMap(u => u.sellers).map((s) => s.track_id),
      };
      this.$store.dispatch("productionModule/general_api", { task, payload })
        .then((res) => {
          console.log(res.data)
          this.$emit("reload_product");
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.massive_delete_loader = false
          this.massive_delete_dialog = false
        });
    },
    updateCreated_at(date){
      console.log('date', date)
      this.date_loader = true;
      const task = 'updateSyncProductDate';
      const payload = {
        product_id: this.selected_product.product_id,
        client_id: this.$store.state.productionModule.loaded_products.find(p => p.product_id === this.selected_product.product_id).client_id,
        list_id: this.selectedProductSpecs.product_info.list,
        date,
      }
      this.$store.dispatch("productionModule/general_api", { task, payload })
        .then((res) => {
          console.log(res.data)
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.date_loader = false
        });
    },
    check_manufacturer(type, value) {
      const data = {
        task: `searching${myCapitallize(JSON.parse(JSON.stringify(type)))}`,
        payload: { value },
      };
      console.log("test data ", data);
      this.$store.dispatch("productionModule/general_api", data).then((res) => {
        const results = res.data.payload
        console.log('res.data.payload[`${type}s`]', res.data.payload[`${type}s`])
        const brands = results[`${type}s`].map(m => ({
          id: m.manufacturer_id,
          name: m.manufacturer_name,
        }));
        console.log("rtesults", results);
        this[`${type}s`] = (results.status) === "success" ? brands : [];
      });
    },
  },
  watch: {
    "sync_manufacturer"(newValue) {
      if (newValue && newValue.length >= 2) {
        this.check_manufacturer("manufacturer", newValue);
      }
    },
  },
  mounted() {
    productionBus.$on('open_massive_delete_dialog', () => { this.massive_delete_dialog = true });
    // if(this.isPending){
    //   this.product_status = this.clients_products.status;
    //   // this.get_product_status();
    // }
  },
};
</script>

<style scoped>
.status-select{
  width: 18px;
}
.datepicker{
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/production/N_ProductDetailsTable2.vue